
import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal;
